
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  inheritAttrs: false
})
export default class Btn extends Vue {
  @Prop({ default: "Loading..." })
  loadingText: string;

  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: false })
  disabled: boolean;

  get isDisabled() {
    if (this.disabled || this.loading) return true;
    return false;
  }
}
